import axios from './Api';

export function CountAid(params: {} = {}) {
  return axios.get<Aid.IAidCount>('/aids/count', { params });
}

export function GetAdminExport() {
  return axios.get<Aid.IAidAdminExport>('/aids/approved/export', { responseType: 'blob' });
}

export function SaveConsumption(data: Array<{ aidId: number; consumption: number }>) {
  return axios.post<Aid.IAidSaveConsumption>('/aids/saveConsumption', data);
}

export function GetAidRange(params: {} = {}) {
  return axios.get<Aid.IAidRange[]>('/aids/range', { params });
}

export function UpdateAid(aidId: number = 0, data: Aid.IAid) {
  return axios.put<Aid.IAidUpdate>(`/aids/${aidId}`, data);
}

export function DeleteAid(aidId: number = 0) {
  return axios.delete(`/aids/${aidId}`);
}

export function CreateAid(data: Aid.IAid) {
  return axios.post<Aid.IAidCreate>('/aids', data);
}

export function GetAid(consumptionPoint: string = '', params: {} = {}) {
  return axios.get<Aid.IAid[]>(`/aids/${consumptionPoint}`, { params });
}

export function GetAidForBackOffice(data = {} as Aid.IGetAidsForBackOffice) {
  return axios.post<Aid.IGetAidForBackOffice[]>('/aids/association/consumption', data);
}

export function ExportReport(data = {} as Aid.IAidExportPartnerData) {
  return axios.post<Aid.IAidExportPartnerResponse>('/aids/export', data, { responseType: 'blob' });
}

export function GetConsumptionPointInterval(consumptionPoint = '') {
  return axios.get<Aid.IAidConsumptionPointInterval[]>(`/aids/association/consumptionPointInterval/${consumptionPoint}`);
}

export function CreateInterval(aidInterval: Aid.ICreateAidConsumptionPointInterval) {
  return axios.post<Aid.ICreateAidConsumptionPointInterval>('/aids/association/consumptionPointInterval', aidInterval);
}

export function EditInterval(aidInterval: Aid.ICreateAidConsumptionPointInterval) {
  return axios.put<Aid.ICreateAidConsumptionPointInterval>(
    `/aids/association/consumptionPointInterval/${aidInterval.consumptionPointIntervalId}`,
    aidInterval
  );
}

export function SaveAidsInterval(consumptionPoint = '', aids: Aid.ISaveAidConsumptionPointInterval[]) {
  return axios.post<Axios.IResponseSuccess>(`/aids/association/consumption/${consumptionPoint}`, aids);
}

export function ModifyAidsInterval(consumptionPoint = '', aids: Aid.ISaveAidConsumptionPointInterval[]) {
  return axios.put<Axios.IResponseSuccess>(`/aids/association/consumption/${consumptionPoint}`, aids);
}

export function GetAidsInterval(consumptionPointInterval = 0) {
  return axios.get<Aid.IAidConsumption[]>(`/aids/association/aidConsumption/${consumptionPointInterval}`);
}

export function ExportAssociationReport(data = {} as Aid.IAidAssociationExport) {
  return axios.post<Aid.IAidExportPartnerResponse>('/aids/association/export', data, { responseType: 'blob' });
}

export function AidCalculate(data = {} as Aid.IAidCalculate) {
  return axios.post<Aid.IAidCalculateResponse>('/aids/association/calculate', data);
}
